import {
  isNavigableDiscoveredAssetKind,
  type NavigableDiscoveredAssetKind,
} from '@terra/ui-design-system';
import type { SignalAssetTypeType } from '@terra/shared-schemas-orchestrator';
import type { OpenMainContentTabInput } from '../store/layoutStore';
import { buildExternalNetworkAssetTab } from '../components/tabs/surface-assets/ExternalNetworkAssetsList';
import { TARGET_TYPE } from './target-scope.utils';

export function isSignalBearingSurfaceAssetType(
  assetType: string | null | undefined,
): assetType is SignalAssetTypeType {
  return (
    assetType === 'DOMAIN' ||
    assetType === 'HOST' ||
    assetType === 'NETWORK_SERVICE' ||
    assetType === 'SOFTWARE' ||
    assetType === 'STORAGE_SERVICE'
  );
}

export function resolveSignalSurfaceAssetLabel({
  assetSummary,
  assetType,
  assetId,
}: {
  assetSummary?: string | null;
  assetType: NavigableDiscoveredAssetKind | SignalAssetTypeType;
  assetId: string;
}): string {
  if (assetSummary) {
    return assetSummary;
  }

  const shortId =
    assetId.length > 8
      ? `${assetId.slice(0, 4)}…${assetId.slice(-4)}`
      : assetId;

  return `${assetType} (${shortId})`;
}

export function getSignalExternalNetworkAssetTab({
  assetId,
  assetType,
  assetSummary,
  targetType,
}: {
  assetId: string | null | undefined;
  assetType: string | null | undefined;
  assetSummary?: string | null;
  targetType: string | null | undefined;
}): OpenMainContentTabInput | undefined {
  if (targetType !== TARGET_TYPE.EXTERNAL_NETWORK) {
    return;
  }

  if (!assetId || !isNavigableDiscoveredAssetKind(assetType)) {
    return;
  }

  return buildExternalNetworkAssetTab({
    entityKind: assetType,
    entityId: assetId,
    label: resolveSignalSurfaceAssetLabel({
      assetSummary,
      assetType,
      assetId,
    }),
  });
}
